<template>
  <Head title="Projects" />

  <BreezeAuthenticatedLayout>
    <main class="container">
      <div class="c-header">
        <a href="" onclick="javascript:history.back(); return false;" class="c-header__back">
          <img src="/images/icons/icon-chevron-left.svg" alt="back">
        </a>
        <h2 class="c-header--h2">グレードを追加：{{ gym.title }}</h2>
      </div>

      <div class="py-12">

        <div class="mt-24">

          <div class="grid place-content-center mt-10">
            <form @submit.prevent="storeProject" class="bg-white shadow-md m-2 p-2 rounded">
              <div class="sm:col-span-6">
                <label for="title" class="block text-sm font-medium text-gray-700"> グレード </label>
                <div class="mt-1">
                  <input type="text" id="title" name="title" v-model="form.title">
                </div>
              </div>

              <div class="mt-24">
                <label for="color">色</label>
                <div class="mt-1">
                  <VSwatches v-model="form.color" :swatches="swatches" show-border=true />
                </div>
              </div>

              <div class="mt-24">
                <input type="hidden" name="gym_id" id="gym_id" v-model="form.gym_id">
                <button type="submit" class="c-button">追加する</button>
              </div>
            </form>
          </div>

        </div>

      </div>
      <Side />
    </main>
  </BreezeAuthenticatedLayout>
</template>

<script>
  import { ref, watchEffect } from 'vue'
  import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue'
  import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
  import Side from '@/Shared/Side'
  import VSwatches from "vue3-swatches";

  export default {
    components: {
      BreezeAuthenticatedLayout,
      Head,
      Link,
      useForm,
      Side,
      VSwatches,
    },
    props: {
      gym: Object
    },
    setup(props) {
      const form = useForm({
        title: null,
        gym_id: props.gym.id,
        color: "#ffffff"
      });
      const swatches = ['#dc143c', '#ff4500', '#ff8c00', '#ffdd00', '#9acd32', '#006400', '#87cefa', '#0000cd', '#191970', '#4b0082', '#8a2be2', '#a9a9a9', '#8b4513', '#222222', '#fc9db8', '#ffffff'];

      const grades = props.grades

      const startdate = ref(null)
      const enddate = ref(null)

      return { form, swatches }
    },
    methods: {
      storeProject() {
        this.form.post('/grades')
      }
    }
  }

</script>
